import React from 'react';
import * as WordpressPluginStyle from "./wordpressPlugin.module.scss"
import {Link} from "gatsby";
import ArrowLeft from '../../../images/homepage/wordpressPlugin/arrow-left.svg'
import {StaticImage} from "gatsby-plugin-image";

function WordpressPlugin() {
  return (
    <div className={WordpressPluginStyle.wordpressPluginWrapper}>
      <div className={WordpressPluginStyle.wordpressPluginWrapper__wordpressPlugin}>
        <div className={WordpressPluginStyle.wordpressPluginWrapper__wordpressPlugin__text}>
          <h2 className={WordpressPluginStyle.wordpressPluginWrapper__wordpressPlugin__text__title}>Free Trafft WordPress Booking plugin</h2>
          <p className={WordpressPluginStyle.wordpressPluginWrapper__wordpressPlugin__text__description}>
            Add a Trafft booking form to your WordPress website, showcase your services and <span>get booked directly from your website.</span>
          </p>
          <Link to='/wordpress' className={WordpressPluginStyle.wordpressPluginWrapper__wordpressPlugin__text__button}>
            Learn more
            <img src={ArrowLeft} alt="arrow"/>
          </Link>
       </div>
        <StaticImage src="../../../images/homepage/wordpressPlugin/mobile-img.webp" alt="Trafft WordPress booking plugin" className={WordpressPluginStyle.wordpressPluginWrapper__wordpressPlugin__img}/>
      </div>
    </div>
  );
}

export default WordpressPlugin;